(function () {
  function init(root) {
    const content = root.querySelector('[data-collection-readmore-content]');
    const toggle = root.querySelector('[data-collection-readmore-toggle]');
    if (!content || !toggle) return;

    function isExpanded() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    function setExpanded(expanded) {
      root.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? 'Voir moins' : 'Voir plus';
    }

    // Mesure si le texte dépasse le clamp, en préservant l’état utilisateur
    function needsTogglePreservingState() {
      const wasExpanded = isExpanded();

      // Force état clamp pour mesurer la hauteur visible
      setExpanded(false);
      void content.offsetHeight;
      const visibleHeight = Math.ceil(content.getBoundingClientRect().height);

      // Force état expanded pour mesurer la hauteur complète
      root.classList.add('is-expanded'); // évite de modifier aria/texte pendant la mesure
      void content.offsetHeight;
      const fullHeight = Math.ceil(content.getBoundingClientRect().height);

      // Restore état utilisateur
      setExpanded(wasExpanded);
      void content.offsetHeight;

      return fullHeight > visibleHeight + 2;
    }

    function refresh() {
      const wasExpanded = isExpanded();
      const shouldShow = needsTogglePreservingState();

      toggle.classList.toggle('is-hidden', !shouldShow);

      // Si le bouton disparaît (texte court), on force l’état replié (cohérent)
      // Sinon, on conserve l’état utilisateur
      if (!shouldShow) {
        setExpanded(false);
      } else {
        setExpanded(wasExpanded);
      }
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setExpanded(!isExpanded());
    });

    refresh();

    // Mobile: le scroll peut déclencher un resize (barre d’adresse)
    // => on conserve l’état expanded lors des refresh()
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 150);
    });
  }

  function boot(scope) {
    const roots = (scope || document).querySelectorAll('[data-collection-readmore]');
    roots.forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
